<div class="flex gap-1 p-0">
  <div class="flex justify-center items-center w-6 h-6 rounded-full bg-neutral-900 flex-shrink-0">
    <flx-icon name="flowx-logo-white"></flx-icon>
  </div>
  <div class="grow text-sm">
    <div class="flex items-center font-bold justify-between">
      <div>{{ message() }}</div>
      <flx-ai-loading-spinner
        (click)="cancelPendingRequest.emit()"
        class="flex justify-center items-center w-6 h-6 cursor-pointer hover:bg-neutral-800 rounded-full"
      />
    </div>
    @if (status()) {
      <div class="relative overflow-hidden">
        <div class="invisible">{{ status() }}</div>
        @for (status of [status()]; track status) {
          <span
            class="inline-flex text-xs font-thin text-neutral-200 items-center h-full absolute top-0"
            @fadeInOut
            >{{ status || 'blaaa' }}</span
          >
        }
      </div>
    }
  </div>
</div>
